import { debounce } from 'lodash';
import { useCallback, useState } from 'react';
import { useGetOptionsQuery } from 'services/options';
import { FindAllOptionsDto, UseQueryOptionsType } from 'types';

type OptionsProps = Pick<FindAllOptionsDto, 'optionTypeId' | 'service'>;
export function useOptions({ optionTypeId, service }: OptionsProps, options?: UseQueryOptionsType) {
  const [keyword, setKeyword] = useState('');
  const {
    data: optionsResponse,
    error,
    isLoading,
    isFetching
  } = useGetOptionsQuery(
    {
      keyword,
      optionTypeId,
      service
    },
    options
  );

  const debouncedKeywordChange = useCallback(
    debounce((keywordValue: string) => {
      setKeyword(keywordValue);
    }, 200),
    [setKeyword]
  );

  const handleSearch = (value: string) => {
    debouncedKeywordChange(value);
  };

  return {
    data: optionsResponse?.data.rows || [],
    count: optionsResponse?.data.count || 0,
    isLoading,
    error,
    isFetching,

    keyword,
    handleSearch
  };
}
